var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"projects"},_vm._l((_vm.projects),function(project,i){return _c('div',{key:i,staticClass:"project"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }